import {
  VALIDATE_OTP_REQUEST,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILURE
} from "../actions/actionTypes";
import esignetClient from '../../auth/esignet';
import IdentityVerificationDTO from "../../models/IdentityVerificationDTO";
import { loginSuccess, setAuthenticated, setLogin } from "../actions/actions";
 

// code: the authorization code from the callback
export const esignetThunk = (code) => {
  return async (dispatch) => {
    dispatch({ type: VALIDATE_OTP_REQUEST });
    try {
      const response = await esignetClient.handleCallback(code);
      if (response && response.data) {
        dispatch(loginSuccess(new IdentityVerificationDTO(response.data)));
        dispatch(setLogin());
        dispatch(setAuthenticated());
      } else {
        dispatch({ type: VALIDATE_OTP_FAILURE, payload: 'No data returned from eSignet.' });
      }
    } catch (error) {
      dispatch({ type: VALIDATE_OTP_FAILURE, payload: error?.message || 'eSignet error' });
    }
  };
};
